import { useState } from "react";
import { Paper, Stack, Typography } from "@mui/material";

import CandidateTransferHeader from "./CandidateTransferHeader";
import CandidateTransferModal from "./CandidateTransferModal";
import CandidateTransferTable from "./CandidateTransferTable";

const CandidateTransfer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("COPY");

  const handleOpenModal = (mode = "COPY") => {
    setModalMode(mode);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Paper elevation={0}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h5" gutterBottom>
            Transfer & Move History
          </Typography>
          <CandidateTransferHeader onOpenModal={handleOpenModal} />
        </Stack>
        <CandidateTransferModal isModalOpen={isModalOpen} onClose={handleCloseModal} mode={modalMode} />

        <CandidateTransferTable />
      </Paper>
    </>
  );
};

export default CandidateTransfer;
